import { useEffect, useState } from 'react'

import { Breadcrumb, Button, Card, Form, Icon, notification, Row, Typography } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

export default function CreateOrEditTopConsultantsType({ match, history }) {
  const defaultFormValues = { active: true }
  const hasAccess = validRule(RULES.MEMBER_TYPE)
  const { id } = match.params

  const [formValues, setFormValues] = useState(defaultFormValues)

  const form = {
    initialValues: formValues,
    validation: yup.object().shape({
      name: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('name')))
    }),
    onSubmit: async (values) => {
      if (id) return updateTopConsultantType(id, values)
      createTopConsultants(values)
    }
  }

  useEffect(() => {
    if (!hasAccess) return history.push('/home')

    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (id) getOneTopConsultant(id)
  }, [id])

  async function createTopConsultants(data) {
    try {
      await request(api.createTopConsultantType(data))
      notification.success({
        description: getMessage('successStoreTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function getOneTopConsultant(id) {
    try {
      const response = await request(api.getOneTopConsultant(id))
      setFormValues(response)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateTopConsultantType(id, data) {
    try {
      await request(api.updateTopConsultantType(id, data))
      notification.success({
        description: getMessage('successupdateTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id ? getMessage('updateTopConsultant') : getMessage('addTopConsultant')
  }

  function renderHeader(submitForm) {
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => history.push(`/topConsultantsTypes/list`)} style={{ cursor: 'pointer' }}>
              Tipos de Top Consultorias
            </Breadcrumb.Item>
            <Breadcrumb.Item>{id ? getMessage('updateTopConsultant') : getMessage('addTopConsultant')}</Breadcrumb.Item>
          </Breadcrumb>

          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={form.validation}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          return (
            <Form layout={'vertical'} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>

                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="name"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
